export default "__VITE_ASSET__PfOWf9lS__"